export enum DemandExportListType {
    Summary = 'SUMMARY',
    Customer = 'CUSTOMER',
    CustomerWithAddresses = 'CUSTOMER_WITH_ADDRESSES',
}

const translationObject: { [Key in DemandExportListType]: string } = {
    [DemandExportListType.Summary]: 'app.demands.exportListType.summary',
    [DemandExportListType.Customer]: 'app.demands.exportListType.customer',
    [DemandExportListType.CustomerWithAddresses]: 'app.demands.exportListType.customerWithAddresses',
};

export const getDemandExportListTypeTranslationId = (exportListType: DemandExportListType): string => {
    return exportListType && translationObject[exportListType];
};
